<template>
  <div class="quota_wrap">
    <!-- <div class="baseInfoBtnBox"> -->
    <!-- <el-button type="primary" @click="addQuota">新增指标</el-button> -->
    <!-- <el-button type="primary">返回</el-button>
      </div> -->
    <!-- <div class="myDivider">监测指标<el-button type="primary">返回</el-button></div> -->
    <el-timeline class="timelines">
      <el-timeline-item :timestamp="item.checkTimeRange" placement="top" name="1" v-for="(item, i) in quotaList" :key="i">
        <el-card>
          <div class="timelineHeader">
            <div class="item">
              周报
            </div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item"></div>
            <div class="item">
              <el-button type="primary" @click="toDetail(true)"><i class="el-icon-edit"></i>详情</el-button>
            </div>
          </div>
          <div class="zhibiaoList">
            <div class="item">
              <!-- <div class="itemName">{{items[0].parentIndexName}}</div> -->
              <div class="itemList">
                <div class="subItem">
                  <el-form>
                    <el-form-item class="itemRow">
                      <template slot="label">血糖监测:</template>
                      <span>本周血糖监测{{item.bloodSugar}}次，异常{{item.abnormalBloodSugar}}次</span>
                      <!-- <span>{{item.checkTimeNowName}}</span> -->
                    </el-form-item>
                    <el-form-item class="itemRow">
                      <template slot="label">血压检测:</template>
                      <span>本周血压监测{{item.bloodSugar}}次，异常{{item.abnormalBloodPressure}}次</span>
                      <!-- <span>{{item.checkTimeNowName}}</span> -->
                    </el-form-item>
                    <el-form-item class="itemRow">
                      <template slot="label">运动情况:</template>
                      <span>{{item.doSport}}</span>
                    </el-form-item>
                    <el-form-item class="itemRow">
                      <template slot="label">饮食情况:</template>
                      <span>{{item.eatFood}}</span>
                    </el-form-item>
                    <el-form-item class="itemRow">
                      <template slot="label">生活评价:</template>
                      <span>{{item.weekEvaluate}}</span>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <div class="add_more" v-if="totalCount < quotaList.length">
      <el-link type="primary" @click="addMore"><i class="el-icon-more"></i>加载更多<i class="el-icon-more"></i></el-link>
    </div>
    <div v-if="quotaList.length === 0" class="noData">暂无数据</div>
    <!-- <el-collapse v-model="activeNames" class="myDivider">
        <el-collapse-item :title="item.checkTimeRange">
        </el-collapse-item>
      </el-collapse> -->
    <!-- <el-pagination
        :current-page.sync="pageNum"
        :page-size="pageSize"
        @size-change="barSizeChange"
        @current-change="barCurrentChange"
        :total="totalCount"
        :page-sizes="[10, 20, 30, 40, 50]"
        background=""
        layout="sizes, prev, pager, next">
      </el-pagination> -->
    <!-- <my-from-dialog
        :isModel="false"
        :title="diaTitle"
        :isShow="isShowDiaFlag"
        :cancelText="'关闭'"
        :scrollHeight="'370px'"
        @ok="closePup('ok')"
        @cancel="closePup"
        @closeCallBack="closePup">
        <template slot="froms">
          <el-form :model="quotaForm" :rules="quotaFormRules" ref="quotaForm" label-width="130px">
            <el-form-item label="选择指标" prop="indexName">
                <el-select v-model="quotaForm.indexName" placeholder="请选择指标" class="baseInp" @change="getQuotaItemList">
                    <el-option v-for="(item,index) in quotaIndexList" :key="index" :label="item.labelName" :value="item" />
                </el-select>
            </el-form-item>
            <el-form-item label="测量日期" prop="checkDateDev">
                <el-date-picker v-model="quotaForm.checkDateDev" type="datetime" placeholder="请选择测量日期" class="baseInp" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
            <el-form-item label="测量时段" prop="checkTimeNow" v-if="quotaForm.indexId == 2" :rules="quotaForm.indexId == 2 ? quotaFormRules.checkTimeNow : [{required: false}]">
                <el-radio-group v-model="quotaForm.checkTimeNow">
                    <el-radio v-for="(item, index) in BloodDataCfgList" :label="item.id" :key="index">{{item.sectionName}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-for="(item,index) in quotaItemList" :key="index">
                <template slot="label">{{item.indexItem}}({{item.indexCompany}})</template>
                <el-input-number v-model="item.itemValue" :min="1" :max="1000"></el-input-number>
                <span class="inpTip">正常值{{item.normalMin}}~{{item.normalMax}}({{item.indexCompany}})</span>
            </el-form-item>
          </el-form>
        </template>
      </my-from-dialog> -->
  </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog'; // 弹窗
export default {
  components: { myFromDialog },
  props: {
    memberId: Number, // 会员id
    pageType: { // 页面类型 1:会员列表 2:慢病会员
      type: String,
      default: '1'
    },
    memberForm: { // 会员表单
      type: Object,
      default: function () {
        return {};
      }
    },
  },
  watch: {
    memberForm: {
      handler: function (n, o) {
        console.log(n, o);
      },
      memberForm: true
    }
  },
  created() {
    this.getQuotaList();
    // this.getBloodCfg();
    // this.getBloodDataCfg();
  },
  data() {
    return {
      isShowDiaFlag: false,
      diaTitle: '新增指标',
      quotaList: [], // 获取已检测指标列表
      BloodDataCfgList: [], // 血标时间段
      quotaIndexList: [], // 指标配置列表
      quotaItemList: [], // 指标项列表
      // ==============================> 添加指标 s
      quotaForm: {
        indexName: '', // 选择指标
        checkDateDev: '', // 测量日期
        checkTimeNow: '', // 测量时间段
      },
      // ==============================> 添加指标 e
      quotaFormRules: this.getQuotaFormRules(), // 规则
      activeNames: ['1'],
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  methods: {
    addMore() {
      this.pageNum += 1;
      this.getQuotaList();
    },
    toDetail(b) { // 点击查看详情
      this.$emit('toDetail', b);
    },
    closePup(state) { // 关闭指标编辑
      if (state == 'ok') {
        this.saveQuota();
      } else {
        this.isShowDiaFlag = false;
      }
    },
    addQuota() { // 新增指标
      this.diaTitle = '新增指标';
      this.isShowDiaFlag = true;
      this.initQuotaForm();
    },
    initQuotaForm() { // 重置表单
      let self = this;
      this.quotaForm = { indexName: '', checkDateDev: '', checkTimeNow: '' };
      this.quotaItemList = [];
      this.$nextTick(() => { self.$refs.quotaForm && self.$refs.quotaForm.clearValidate(); })
    },
    getQuotaList() { // 获取指标历史列表
      this.$https.get('system/memberWeekReport/list', { memberId: this.memberId, pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        if (res.data && res.data.records) {
          res.data.records.map((d) => {
            this.quotaList.push(d);
          });
          console.log("获取指标列表=======>", res);
          this.totalCount = res.data.total;
        }
      }).catch(res => {
        // this.$message.error('接口请求异常');
      })
    },
    getBloodCfg() { // 获取指标配置列表
      this.$https.get('system/memberLabel/list', {}).then(res => {
        this.quotaIndexList = res.data || [];
        console.log("获取指标配置列表=======>", res);
      }).catch(res => {

      })
    },
    getBloodDataCfg() { // 获取指标时间段列表
      this.$https.get('system/bloodConfig/getBloodConfigList', { type: 2 }).then(res => {
        this.BloodDataCfgList = res.data;
        console.log("获取指标时间段查询列表========>", res);
      }).catch(res => {

      })
    },
    getQuotaItemList(item) { // 获取指标项列表
      this.quotaForm.indexName = item.labelName;
      this.quotaForm.indexId = item.id;
      this.$https.get('system/member-detection-index-config/getDetectionIndexConfigByLableId', { laberId: item.id }).then(res => {
        this.quotaItemList = res.data;
        console.log("获取指标项列表=============>", res);
      }).catch(res => {

      })
    },
    getSaveReqParams() { // 获取指标保存参数
      let list = [];
      this.quotaItemList.map((d, i) => {
        list.push({
          company: d.indexCompany,
          memberId: this.memberForm.id,
          indexId: this.quotaForm.indexId,
          detectionIndexName: d.indexItem,
          detectionIndexId: d.id,
          itemValue: d.itemValue,
          checkDate: this.quotaForm.checkDateDev,
          valueType: 1,
          checkTimeNow: this.quotaForm.checkTimeNow,
          createPerson: localStorage.getItem('ms_username_manage')
        })
      })
      // console.log(list);
      return list;
    },
    saveQuota() { // 保存指标
      let flag = false;
      this.$refs.quotaForm.validate(valid => { flag = valid; });
      if (!flag) return;
      this.$https.post('system/value/indexItem/insertItemValue', { itemValueList: this.getSaveReqParams() }).then(res => {
        // this.quotaItemList = res.data;
        this.isShowDiaFlag = false;
        this.getQuotaList();
        this.$message.success('保存成功');
      }).catch(res => {

      })
    },
    getQuotaFormRules() { // 校验
      return {
        indexName: { required: true, message: '请选择指标', trigger: 'change' },
        checkDateDev: { required: true, message: '请选择日期', trigger: 'change' },
        checkTimeNow: { required: true, message: '请选择时间段', trigger: 'change' }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.baseInfoBtnBox {
    padding: 10px;
}
.timelines {
    margin-right: 50%;
    width: 80%;
}
.timelineHeader {
    display: flex;
    display: -webkit-flex;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e3e3e3;
    .item {
        flex: 1;
        -webkit-flex: 1;
        // text-align: center;
    }
    .item:first-child {
        text-align: left;
    }
    .item:last-child {
        text-align: right;
    }
}
.zhibiaoList {
    .itemName {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .subItem /deep/ .el-form-item--mini.el-form-item,
    .subItem /deep/ .el-form-item--small.el-form-item {
        margin-bottom: 0px;
    }
    .itemRow {
        // span {
        //     margin-left: 100px;
        // }
    }
}
.myDivider {
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    /deep/ .el-collapse-item__header {
        margin-bottom: 15px;
        padding: 0 10px;
        background: #f1f1f1;
        border-left: 4px solid #f56c6c;
        font-size: 15px;
        font-weight: bold;
    }
}
.add_more {
    text-align: center;
}
.noData {
    margin: 30px;
    color: red;
    font-size: 15px;
    text-align: center;
    font-weight: bold;
}
</style>
